import cx from 'classnames'
import Styles from './ActivityEvent.module.scss'
import { BaseActivityEvent } from './BaseActivityEvent'
import { Actor } from './Actor'
import { ArticleInformalFeedbackReviewsCreatedEvent, BaseActivityEventProps } from './Types'
import { InformalFeedbackRequestAction } from './InformalFeedbackRequestAction'
import { ProseDisplay } from 'common/ProseInput/ProseDisplay'
import { EventIconContainer } from './EventIconContainer'
import { Approval } from 'blaze-ui/icons'
import { useModals } from 'almanac-ui/Modal'
import { ReviewSummaryModal } from 'components/ReviewSummaryModal/ReviewSummaryModal'

interface Props extends Partial<BaseActivityEventProps> {
  event: ArticleInformalFeedbackReviewsCreatedEvent
}

const ArticleInformalFeedbackReviewsCreated = ({ event, ...props }: Props) => {
  const { user, data } = event
  const { reviews, request, branch } = data
  const { openModal } = useModals()

  if (branch) {
    return null
  }

  const { actions, className, ...rest } = props

  const handleClick = (e: MouseEvent) => {
    openModal(ReviewSummaryModal, { requestId: request.id })
  }

  const reviewText = (reviews[0]?.iteration || -1) > 0 ? 'for another review' : 'to review'

  return (
    <BaseActivityEvent
      {...rest}
      onClick={handleClick}
      className={cx(data.initial && Styles.informalFeedbackRequest, className)}
      icon={
        <EventIconContainer>
          <Approval size={16} />
        </EventIconContainer>
      }
      timestamp={event.timestamp}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> asked{' '}
          <Actor
            count={reviews.length}
            displayName={reviews[0]?.reviewer?.display_name}
            userId={reviews[0]?.reviewer?.id}
          />{' '}
          {reviewText}
        </>
      }
      message={request.html_description ? <ProseDisplay html={request.html_description} /> : request.description}
      actions={
        <>
          <InformalFeedbackRequestAction event={event} />
          {actions}
        </>
      }
    />
  )
}

export { ArticleInformalFeedbackReviewsCreated }
